import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import type { IncomingHttpHeaders } from 'http';

import { carValuationApi } from '../../../../api/carValuationApi';
import { formatAuthorizationHeader } from '../../../../helpers/auth';
import { useAuthOptions } from '../../../../contexts/UserContext';

const minMaxSchema = z.object({ min: z.number(), max: z.number() });

export const carValuationResponseSchema = z.object({
  valuation: z.number(),
  expectedDealerOfferRange: minMaxSchema,
  privateMarketOfferRange: minMaxSchema,
});

export type CarValuationResponse = z.infer<typeof carValuationResponseSchema>;

const fetchCarValuation = async ({
  registration,
  mileage,
  headers,
}: {
  registration: string;
  mileage: string;
  headers: IncomingHttpHeaders;
}): Promise<CarValuationResponse> => {
  const { data } = await carValuationApi.getCarValuation(
    registration,
    mileage,
    'HOMEPAGE',
    headers,
  );
  return carValuationResponseSchema.parse(data);
};

export const useGetCarValuation = () => {
  const { accessToken } = useAuthOptions();

  return useMutation({
    mutationFn: (args: { registration: string; mileage: string }) =>
      fetchCarValuation({
        ...args,
        headers: formatAuthorizationHeader(accessToken),
      }),
    meta: { noToast: true },
  });
};
